import { dateFormat24hr } from '../date';
import { yAxis } from './graphYAxis';

export const chartOptions = {
  chart: {
    type: 'spline',
    zoomType: 'x',
    panning: {
      enabled: true,
      type: 'x'
    },
    panKey: 'shift',
    resetZoomButton: {
      position: {
        x: -10,
        y: 10
      },
      relativeTo: 'chart'
    }
  },
  title: {
    text: ''
  },
  xAxis: {
    type: 'datetime',
    breaks: [],
    ordinal: false, //  ADD
    gapGridLineWidth: 0,
    title: {
      text: 'Time',
      align: 'middle'
    }
  },
  yAxis,
  series: [],
  tooltip: {
    shared: true,
    formatter: function () {
      return [`<b>${dateFormat24hr(this.x)}</b>`].concat(
        this.points
          ? this.points.map(function (point) {
              return `<br><span style="color:${
                point.series.color
              }">\u25CF</span>  <b>${point.series.name}</b> : ${parseFloat(point.y).toFixed(2)} ${point.series.options.tooltip.valueSuffix}`;
            })
          : []
      );
    }
  },
  legend: {
    enabled: true
  },
  credits: {
    enabled: false
  }
};
